import { createReducer, on } from '@ngrx/store';
import { CHART_OPTION_TO_PLOT_OPTION_MAP } from 'ChartApp/ts/apps/scatter-plot/state/constants';
import { SCATTER_PLOT_PLOT_OPTIONS_DEFAULT } from 'ChartApp/ts/features/scatter-plot-page-shared/components/scatter-plot-customize-modal/scatter-plot-plot-options.constants';
import { getPlotOptionId } from 'ChartApp/ts/apps/scatter-plot/utils';
import { setChartOption } from '../chart-options/chart-options.actions';
import { setScatterPlot } from '../scatter-plot.actions';
import { addScatterPlotSecurities, removeScatterPlotSecurity } from '../securities/securities.actions';
import { submitCustomizeModal } from './plot-options.actions';
export const plotOptions = createReducer({}, on(addScatterPlotSecurities, (state, action) => {
    const nextState = { ...state };
    const scatterPlotPlotOptions = { ...SCATTER_PLOT_PLOT_OPTIONS_DEFAULT };
    Object.entries(action.scatterPlotChartOptions).forEach(([chartOptionName, chartOptionVal]) => {
        // For each chart option, check if it overrides a plot option. Not all chart options override plot options.
        // ex: 'displayLegend` doesn't override plot options.
        // The chart option overrides a plot option if the chart option name maps to a plot option name.
        const plotOptionName = CHART_OPTION_TO_PLOT_OPTION_MAP[chartOptionName];
        if (plotOptionName) {
            // Override the plot option value with the chart option value.
            // Since chart options are either selected or not selected, they are always boolean values.
            scatterPlotPlotOptions[plotOptionName] =
                chartOptionVal;
        }
    });
    action.scatterPlotSecurities.forEach((scatterPlotSecurity) => {
        const plotOptionId = getPlotOptionId(scatterPlotSecurity);
        // If the user is overriding an individual security on a list, it will already have plot options and
        // we do not want to use the default plot options.
        if (plotOptionId in state)
            return;
        nextState[plotOptionId] = scatterPlotPlotOptions;
    });
    return nextState;
}), on(submitCustomizeModal, (state, action) => {
    return action.plotOptions;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.plotOptions;
}), on(removeScatterPlotSecurity, (state, action) => {
    const { scatterPlotSecurity } = action;
    const plotOption = getPlotOptionId(scatterPlotSecurity);
    const nextState = { ...state };
    delete nextState[plotOption];
    return nextState;
}), 
// Chart Option Actions
on(setChartOption, (state, action) => {
    // Not all chart options have a matching plot option to override i.e. displayLegend
    // Check if there is a plot option to override
    if (!Object.keys(CHART_OPTION_TO_PLOT_OPTION_MAP).includes(action.chartOption.value))
        return state;
    const plotOptionName = CHART_OPTION_TO_PLOT_OPTION_MAP[action.chartOption.value];
    // Set every corresponding plot option's value to the chart option's value
    const newState = { ...state };
    // Set every corresponding plot option's value to the chart option's value
    Object.keys(newState).forEach((plotOptionId) => {
        newState[plotOptionId] = {
            ...newState[plotOptionId],
        };
        newState[plotOptionId][plotOptionName] =
            action.chartOption.selected;
    });
    return newState;
}));
